// "https://www.ro-cd.com"; //配置接口地址
// "https://manager.nmgkjcx.cn"; //配置接口地址
export const baseURL = 'https://manager.qzkj.vip';
// export const baseURL = 'https://manager.qzkj.vip';